import { Library } from "lucide-react";

interface GuestCatalogEmptyStateProps {
  title: string;
  hint: string;
}

export function GuestCatalogEmptyState({ title, hint }: GuestCatalogEmptyStateProps) {
  return (
    <div className="flex flex-col items-center py-12 text-center" role="status">
      <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-gray-100 text-gray-400">
        <Library className="h-6 w-6" aria-hidden />
      </div>
      <p className="text-base font-medium text-gray-900">{title}</p>
      <p className="mt-1 max-w-md text-sm text-gray-500">{hint}</p>
    </div>
  );
}
